//------------------------------------------------------------------------------
//     This code was generated by a tool.
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
//------------------------------------------------------------------------------  
enum MembershipDiscountType {

  EmployeeDiscount = 1,

  FriendsAndFamily = 2,

  Landowner = 3,

  Prepaid = 4,

  MemberReferral = 5,

  AdCampaignRadio = 6,

  AdCampaignTV = 7,

  AdCampaignDirectMail = 8,

  AdCampaignMagazine = 9,

  AdCampaignNewsPaper = 10,

  Other = 11,

}

export default MembershipDiscountType;